export function CheckSumXOR(message) {
  let ret = 0;

  for (let char of message) {
    ret ^= char.charCodeAt(0);
  }
  return ret;
}

export function ExtremeLimitation(lowerLimit, upperLimit, value) {
  if (value > upperLimit) {
    return upperLimit;
  } else if (value < lowerLimit) {
    return lowerLimit;
  }
  return value;
}

/**
 * LineEquation_LimitedByExtremePoints - Calculate y-coordinate (line-equation) betwen two points x1,y1 and x2,y2 for given x
 * @param {x1} x1 - x1 coordinate of point 1
 * @param {y1} y1 - y1 coordinate of point 1
 * @param {x2} x2 - x2 coordinate of point 2
 * @param {y2} y2 - y2 coordinate of point 2
 * @param {x} x - x coordinate to find out y
 * @return {y} y coordinate for given x
 **/
export function LineEquation_LimitedByExtremePoints(x1, y1, x2, y2, x) {
  if (x >= x2) {
    return y2;
  } else if (x <= x1) {
    return y1;
  } else {
    return ((y1 - y2) / (x1 - x2)) * x + (y2 * x1 - y1 * x2) / (x1 - x2);
  }
}

/**
 *
 **/
/* export function LineEquationX_LimitedByExtremePoints(x1, y1, x2, y2, y) {
  if (y >= y2) {
    return y2;
  } else if (y <= y1) {
    return y1;
  } else {
    return ((x1 - x2) / (y1 - y2)) * y + (x2 * y1 - x1 * y2) / (y1 - y2);
  }
}
 */
export function Math_LinearInterpolationY(x1, y1, x2, y2, x) {
  if (x2 == x1) {
    return (y2 + y1) / 2;
  }
  return y1 + ((y2 - y1) / (x2 - x1)) * (x - x1);
}

export function Math_LinearInterpolationX(x1, y1, x2, y2, y) {
  if (y2 == y1) {
    return (x2 + x1) / 2;
  }
  return x1 + ((x2 - x1) / (y2 - y1)) * (y - y1);
}

/**
 * IsInt - Based on input determinate if number is int
 * @param {n} - Input number
 * @return {result} - Output is true or false
 **/
export function IsInt(n) {
  return Number(n) === n && n % 1 === 0;
}

/**
 * IsFloat - Based on input determinate if number is float
 * @param {n} - Input number
 * @return {result} - Output is true or false
 **/
export function IsFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}

/**
 * Negative2Signed32Integer - Convert negative number to signed 32 bit integer
 * @param {value} - Input value
 * @return {result} - Return result
 **/
export function Negative2Signed32Integer(value) {
  value = Number(value);

  if (Math.sign(value) == -1) {
    value = 0xffffffff + value + 1;
  }

  return value;
}

/**
 * Int2Hexa -
 * @param {value} - Input value
 * @return {result} - Return result
 **/
export function Int2Hexa(value) {
  value = Number(value);

  let result = Negative2Signed32Integer(value).toString(16).toUpperCase();

  while (result.length < 8) {
    result = "0" + result;
  }

  return result;
}

/**
 * Float2Hexa -
 * @param {value} - Input value
 * @return {result} - Return result
 **/
export function Float2Hexa(value) {
  value = Number(value);

  let result = Float2Bin32(value);

  result = parseInt(result, 2).toString(16).toUpperCase();

  while (result.length < 8) {
    result += "0";
  }

  /*   console.warn("Final result: " + result); */

  return result;
}

/**
 * Value2Hexa - Based on input value, function determinate if number is float or int.
 * If number is int type, value is only converted to hexadecimal format
 * If number is float type, value is converted to binary32 (IEEE 754) and converted to hexadecimal format
 * @param {value} - The integer to be converted
 * @return {result} - The binary (IEEE 754) representation of integer / float in hexadecimal format
 **/
export function Value2Hexa(value) {
  let result;

  if (IsInt(value) === true) {
    result = Int2Hexa(value);

    return result;
  }

  if (IsFloat(value) === true) {
    result = Float2Bin32(value);

    result = parseInt(result, 2).toString(16).toUpperCase();

    return result;
  }
}

/**
 * Float2Bin32 - This function convert floating point number to binary representation
 * https://en.wikipedia.org/wiki/IEEE_754
 * @param {value} - The value to be converted
 * @return {result} - The binary (IEEE 754) representation of entered value
 **/
export function Float2Bin32(value) {
  value = Number(value);

  let normalPart;
  let fracPart;
  let base2float;
  let bin32exp;
  let bin32mantissa;
  let bin32float;
  let sign;
  let exponent;

  /*   console.warn("Input value: " + value); */

  if (value == 0) {
    return "00000000000000000000000000000000";
  }

  normalPart = parseInt(Math.abs(value));

  /*   console.warn("normal part: " + normalPart); */

  fracPart = Math.abs(value) - normalPart;
  /* 
  console.warn("fractional part: " + fracPart); */

  sign = Math.abs(value) === value ? "0" : "1";

  /*   console.warn("sign: " + sign); */

  base2float = Convert2Bin(normalPart) + "." + Frac2Bin(fracPart);

  /*   console.warn("Convert normal part to Binary: " + Convert2Bin(normalPart));

  console.warn("Convert fractional part to Binary: " + Frac2Bin(fracPart)); */

  exponent = base2float.indexOf(".") - base2float.indexOf("1");

  if (exponent > 0) exponent = exponent - 1;

  bin32exp = InsertZeroes(Convert2Bin(127 + exponent), 8, 1);

  /*   console.warn("Exponent: " + exponent);
  console.warn("Exponent in bin32: " + bin32exp); */

  bin32mantissa = InsertZeroes(Binary32Mantissa(base2float, exponent), 23, 0);
  /* 
  console.warn("Mantisa in bin32: " + bin32mantissa); */

  bin32float = (bin32exp + bin32mantissa).slice(0, 31);

  /*   console.warn("Result in bin32: " + sign + bin32float); */

  return sign + bin32float;
}

/**
 * Convert2Bin
 * @param {input} - The integer to be converted
 * @return {bin} - The binary representation
 **/
function Convert2Bin(input) {
  if (input === 0 || input === 1) return "" + input;

  let binary = "";
  while (input !== 0) {
    binary = binary + (input % 2);
    input = parseInt(input / 2);
  }

  return binary.split("").reverse().join("");
}

/**
 * Frac2Bin - Convert fractional part to binary representation
 * @param {input} - The fractional part
 * @return {bin} - The binary representation
 **/
function Frac2Bin(input) {
  if (input === 0) return "" + input;

  let limit = 0;
  let binary = "";

  while (input !== 0 && limit < 32) {
    input = input * 2;
    if (input >= 1) {
      binary = binary + "1";
      input -= 1;
    } else binary = binary + "0";
    limit++;
  }

  return binary;
}

/**
 * Binary32Mantissa - Returns the mantissa from the normalized number
 * @param {input} - The normalized number
 * @param {exp} - The 'e' value required to get the normalized number
 * @return {result} - The mantissa portion
 **/
function Binary32Mantissa(input, exp) {
  input = input.replace(/\./, "");

  return exp > 0 ? input.slice(1, input.length) : input.slice(1 - exp, input.length);
}

/**
 * InsertZeroes - To pad the number to expected length
 * @param {input} - The string to be padded
 * @param {total} - The max length of the string
 * @param {dir} - The direction to add the padded bits
 * @return {result} - The padded String
 **/
function InsertZeroes(input, total, dir) {
  var padLen = total - input.length;
  var padStr = "";

  while (padLen-- > 0) {
    padStr = padStr.concat("0");
  }

  return dir === 1 ? padStr.concat(input) : input.concat(padStr);
}
